import { createMedia } from '@artsy/fresnel'
import React from 'react'

const SiteMedia = createMedia({
  breakpoints: {
    mobileSmall: 0,
    mobileMedium: 480,
    tabletSmall: 575,
    ipadVertical: 768,
    tabletMedium: 992,
    ipadHorizontal: 1024,
    desktopSmall: 1200,
    desktopMedium: 1440,
    desktopLarge: 1920,
    desktopXL: 1680,
    desktopXXL: 2200,
  },
})

export const mediaStyle = SiteMedia.createMediaStyle()
export const { Media } = SiteMedia

// The client renders every breakpoint like the server does (mediaStyle hides
// the others), otherwise hydration finds different markup
export const MediaContextProvider = ({
  children,
}: {
  children?: React.ReactNode
}) => (
  <SiteMedia.MediaContextProvider disableDynamicMediaQueries>
    {children}
  </SiteMedia.MediaContextProvider>
)
